"use client"

import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Typography, Box, Tabs, Tab, List, ListItem, ListItemButton, ListItemText, Divider } from "@mui/material"
import { Assignment, RateReviewOutlined, Feedback, Timeline, AccountTree } from "@mui/icons-material"
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const PerformanceSidebar = ({ isManager }) => {
  const navigate = useNavigate()

  const handleNavigation = (path) => {
    if (path === "/navbar") {
      localStorage.removeItem("currentEmployeeId")
      localStorage.removeItem("currentEmployeeName")
      navigate(path)
    } else if (path === "/performance") {
      navigate("/view")
    } else {
      navigate(path)
    }
  }

  return (
    <List>
      <Typography variant="h4" sx={{ px: 2, py: 1, fontWeight: "bold" }}>
        View Performance
      </Typography>
      <Divider />

      {isManager ? (
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleNavigation("/performance")}>
            <ListItemText primary="Performance Management" />
          </ListItemButton>
        </ListItem>
      ) : (
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleNavigation("/navbar")}>
            <ListItemText primary="View Performance" />
          </ListItemButton>
        </ListItem>
      )}
    </List>
  )
}

const SharedNavbar = ({ children }) => {
  const [currentUser, setCurrentUser] = useState({
    employee_id: "default",
    firstName: "Employee",
    lastName: "View",
  })
  const [selectedTab, setSelectedTab] = useState("goals")

  const navigate = useNavigate()
  const location = useLocation()

  const routeToTab = {
    "/view": "goals",
    "/viewreview": "reviews",
    "/viewfeedback": "feedback",
    "/viewpip": "improve",
    "/viewsuccession": "succession",
  }

  useEffect(() => {
    const currentPath = location.pathname
    const tabValue = routeToTab[currentPath] || "goals"
    setSelectedTab(tabValue)

    const storedEmployeeId = localStorage.getItem("currentEmployeeId")
    const storedEmployeeName = localStorage.getItem("currentEmployeeName")

    if (storedEmployeeId) {
      setCurrentUser({
        employee_id: storedEmployeeId,
        firstName: storedEmployeeName || "Employee",
        lastName: "",
      })
    }
  }, [location.pathname, navigate])

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)

    const routes = {
      goals: "/view",
      reviews: "/viewreview",
      feedback: "/viewfeedback",
      improve: "/viewpip",
      succession: "/viewsuccession",
    }

    navigate(routes[newValue])
  }

  return (
    <>
      {/* Main Page Header */}
      <Box sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", }}>
          View Performance
        </Typography>
      </Box>

      {/* Sticky 5-tab navigation */}
      <Box
        sx={{
          position: "sticky",
          top: "0px", // Try 0px first, then adjust if needed
          zIndex: 100,
          backgroundColor: "white",
          borderBottom: "1px solid #e0e0e0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          marginTop: 0,
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            backgroundColor: "#f5f5f5",
            "& .MuiTab-root": {
              fontWeight: "medium",
              py: 1.5,
              color: "text.primary",
              minHeight: 64, // Changed back to 64 from 124
            },
            "& .Mui-selected": {
              color: "primary.main",
              fontWeight: "bold",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "primary.main",
              height: 3,
            },
          }}
        >
          <Tab icon={<Assignment />} label="Goals & Objectives" value="goals" />
          <Tab icon={<RateReviewOutlined />} label="Performance Reviews" value="reviews" />
          <Tab icon={<Feedback />} label="Feedback System" value="feedback" />
          <Tab icon={<Timeline />} label="Improvement Plans" value="improve" />
          <Tab icon={<AccountTree />} label="Succession Planning" value="succession" />
        </Tabs>
      </Box>

      {/* Content Area */}
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          {selectedTab === "goals" && "Goals & Objectives"}
          {selectedTab === "reviews" && "Performance Reviews"}
          {selectedTab === "feedback" && "Feedback System"}
          {selectedTab === "improve" && "Improvement Plans"}
          {selectedTab === "succession" && "Succession Planning"}
        </Typography>

        {children}
      </Box>
    </>
  )
}

export default SharedNavbar
